<div [class]="class" [style]="style">
    <hr/>
</div>